/**
 * @author Andrés Ferreira
 * @Copyright (c) Infotrack. All rights reserved.
 */
import Tabla from '@infotrack/presentacion-componentes/tabla';
import React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import { ITablaFabricantesVistaProps } from '../interfaces';
import { acciones, columnas, opciones } from './constantes';

const VistaFabricantes: React.FunctionComponent<ITablaFabricantesVistaProps & InjectedIntlProps> = ({
    fabricantess,
    cargarFabricantes,
    confirmarEliminacion,
    intl,
    manejarFormulario,
}) => (
    <div>
        <Tabla
            columns={columnas(intl.formatMessage)}
            data={fabricantess}
            actions={acciones(manejarFormulario, cargarFabricantes, intl.formatMessage, confirmarEliminacion)}
            options={opciones}
        />
    </div>
);

export default injectIntl(VistaFabricantes);
